export function extractFormData(submitButton) {
  var form = submitButton.closest('form');
  if (!form) {
    console.error('The submit button does not belong to any form.');
    return null;
  }
  var variantIdInput = form.querySelector('input[name="id"]');
  if (!variantIdInput || !variantIdInput.value) {
    console.error('The form does not contain a valid "id" input.');
    return null;
  }
  var quantity = 1;
  var quantityInput = form.querySelector('input[name="quantity"]');
  if (quantityInput && quantityInput.value) {
    quantity = parseInt(quantityInput.value, 10);
  }
  var propertyStyle = form.querySelector('input[name="properties[Style]"]');
  var formData = {
    items: [{
      id: parseInt(variantIdInput.value, 10),
      quantity: quantity,
      properties: {
        'Style': propertyStyle === null || propertyStyle === void 0 ? void 0 : propertyStyle.value
      }
    }],
    sections: 'ajax-side-cart,header'
  };
  return formData;
}
export function parseHTMLSection(section) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(section, 'text/html');
  return doc.body.firstChild;
}